import type { NavigateFunction } from 'react-router-dom';
import { resolveCustomerSignInPath } from '../auth/customerAuthPaths.js';
import { parkPaymentResumeReturnTarget } from '../../shared/session/returnTarget.js';

/**
 * G1 — receipt Card login CTA: park payment-resume then path-tenant sign-in.
 * Returns false when park fails (caller stays on receipt).
 */
export function navigateReceiptLoginAfterPaymentPark(
  returnPathWithQuery: string,
  tenantCode: string,
  navigate: NavigateFunction,
): boolean {
  const parked = parkPaymentResumeReturnTarget(returnPathWithQuery, {
    tenantCode,
    source: 'checkout',
  });
  if (parked === null) {
    return false;
  }
  navigate(resolveCustomerSignInPath(tenantCode));
  return true;
}
